import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
	OneToOne,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { LegacyEmailHistoryEntity } from './legacy-email-history.entity';
import { LegacyEmailTemplateFileEntity } from './legacy-email-template-file.entity';
import { LegacyEmailTemplateTagEntity } from './legacy-email-template-tag.entity';
import { MessageEntity } from './message.entity';
import { ObjectEntity } from './object.entity';

@Index('_email_template__campaign_object_idx', ['fkObjectId'], {})
@Entity('_email_template')
export class LegacyEmailTemplateEntity extends BaseEntity {
	@Column('varchar', { name: '_name', length: 128 })
	public name!: string;

	@Column('text', { name: '_code', nullable: true })
	public code!: string | null;

	@Column('longtext', { name: '_html', nullable: true })
	public html!: string | null;

	@Column({
		type: 'boolean',
		name: '_isWidget',
		nullable: true,
		width: 1,
		default: () => "'0'",
	})
	public isWidget!: boolean | null;

	@Column('int', {
		name: '_fk__message__id',
		nullable: true,
		unsigned: true,
		unique: true,
	})
	public fkMessageId!: number | null;

	@Column('int', { name: '_fk__object__id', nullable: true, unsigned: true })
	public fkObjectId!: number | null;

	@Column('varchar', { name: '_alias', nullable: true, length: 50 })
	public alias!: string | null;

	@OneToOne(() => MessageEntity, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__message__id', referencedColumnName: 'id' }])
	public fkMessage!: MessageEntity | null;

	@ManyToOne(() => ObjectEntity, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__object__id', referencedColumnName: 'id' }])
	public fkObject!: ObjectEntity | null;

	@OneToMany(
		() => LegacyEmailHistoryEntity,
		(emailHistory) => emailHistory.fkEmailTemplate,
		{},
	)
	public emailHistories!: Array<LegacyEmailHistoryEntity>;

	@OneToMany(
		() => LegacyEmailTemplateFileEntity,
		(emailTemplateFile) => emailTemplateFile.fkEmailTemplate,
		{},
	)
	public emailTemplateFiles!: Array<LegacyEmailTemplateFileEntity>;

	@OneToMany(
		() => LegacyEmailTemplateTagEntity,
		(emailTemplateTag) => emailTemplateTag.fkEmailTemplate,
		{},
	)
	public emailTemplateTags!: Array<LegacyEmailTemplateTagEntity>;
}
